const apiUrl = process.env.VUE_APP_API_BASEURL;

export default {
  paymentMethods: (communeId: string) => `${apiUrl}/v2/checkout/${communeId}/paymentMethod`,
  startPayment: (orderId: string, paymentMethod: string, localeSelected: string = 'en') =>
    `${apiUrl}/v2/checkout/startPayment/${orderId}?paymentMethod=${paymentMethod}&appType=web&localeSelected=${localeSelected}`,
  preparePayment: `${apiUrl}/v2/checkout/preparePayment`,
  freeCheckout: `${apiUrl}/v2/checkout/freeCheckout`,
  verifyPayment: `${apiUrl}/v2/checkout/verifyPayment`,
  directPayment: `${apiUrl}/v2/checkout/direct`,
  consentStoring: `${apiUrl}/v2/checkout/consent`,
};
